/* tslint:disable */
/* eslint-disable */
/**
 * STRY API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SurveyHistoryAnswer
 */
export interface SurveyHistoryAnswer {
    /**
     * 
     * @type {string}
     * @memberof SurveyHistoryAnswer
     */
    surveyType?: string;
    /**
     * 
     * @type {number}
     * @memberof SurveyHistoryAnswer
     */
    promisPhysicalFunction?: number;
    /**
     * 
     * @type {number}
     * @memberof SurveyHistoryAnswer
     */
    promisPainInterference?: number;
    /**
     * 
     * @type {string}
     * @memberof SurveyHistoryAnswer
     */
    surveyDate?: string;
}

export function SurveyHistoryAnswerFromJSON(json: any): SurveyHistoryAnswer {
    return SurveyHistoryAnswerFromJSONTyped(json, false);
}

export function SurveyHistoryAnswerFromJSONTyped(json: any, ignoreDiscriminator: boolean): SurveyHistoryAnswer {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'surveyType': !exists(json, 'survey-type') ? undefined : json['survey-type'],
        'promisPhysicalFunction': !exists(json, 'promis-physical-function') ? undefined : json['promis-physical-function'],
        'promisPainInterference': !exists(json, 'promis-pain-interference') ? undefined : json['promis-pain-interference'],
        'surveyDate': !exists(json, 'survey-date') ? undefined : json['survey-date'],
    };
}

export function SurveyHistoryAnswerToJSON(value?: SurveyHistoryAnswer | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'survey-type': value.surveyType,
        'promis-physical-function': value.promisPhysicalFunction,
        'promis-pain-interference': value.promisPainInterference,
        'survey-date': value.surveyDate,
    };
}


